const diseaseDisplayOptions = [
  { value: '1', label: 'Asthma & COPD' },
  { value: '2', label: 'Seasonal Allergies' },
  { value: '3', label: 'All Allergies' },
]

export default diseaseDisplayOptions
